const translations = {
  en: {
    // Navbar
    home: 'Home',
    about: 'About',
    skills: 'Skills',
    portfolio: 'Portfolio',
    ai: 'AI',
    contact: 'Contact',
    hireMeNav: 'Hire Me',

    // Hero
    greeting: "Hello, I'm",
    title: 'Software Developer',
    description: "Passionate freelance developer with 3+ years of experience crafting modern, responsive web applications using cutting-edge technologies.",
    yearsExp: 'YEARS EXP.',
    projectsCompleted: 'PROJECTS',
    happyClients: 'CLIENTS',
    hireMe: "Let's Work Together",
    viewWork: 'View My Work',
    scrollDown: 'SCROLL',
    typingTexts: ['React Specialist', 'Vue.js Developer', 'Software Engineer', 'Node.js Expert'],
    fastDelivery: 'Fast Delivery',
    topRated: 'Top Rated',

    // About
    aboutTag: 'About Me',
    aboutTitle: 'About Me',
    whoAmI: 'Who Am I?',
    aboutDescription: "I'm a software developer from Egypt with over 3 years of freelance experience. I've developed expertise in both frontend and backend technologies, creating seamless digital experiences and solving complex problems with clean, efficient code.",
    name: 'NAME',
    age: 'AGE',
    years: 'Years',
    status: 'STATUS',
    freelancer: 'Freelancer',
    from: 'FROM',
    fromValue: 'Egypt',
    experience: 'EXPERIENCE',
    frontendDev: 'Frontend Development',
    frontendDesc: 'Creating beautiful, responsive user interfaces with modern frameworks like React, Next.js, Vue.js, and Nuxt.js.',
    backendDev: 'Backend Development',
    backendDesc: 'Building robust server-side applications with secure APIs and efficient databases.',
    fullstackDev: 'Software Solutions',
    fullstackDesc: 'End-to-end web application development from concept to deployment with modern tech stacks.',
    letsWork: "Let's Work Together",

    // Skills
    skillsTag: 'My Skills',
    skillsTitle: 'My Skills',
    skillsSubtitle: 'Technologies I work with daily to build modern web applications.',
    frontend: 'Frontend',
    backend: 'Backend',
    otherSkills: 'Other',

    // Projects
    projectsTag: 'Portfolio',
    projectsTitle: 'Work Samples',
    projectsSubtitle: 'A showcase of my recent projects and work samples.',
    noProjects: 'No work samples yet.',
    adminLogin: 'Admin Access',
    adminLogout: 'Logout',
    enterPassword: 'Enter admin password',
    loginBtn: 'Login',
    wrongPassword: 'Wrong password!',
    addProject: 'Add Project',
    editProject: 'Edit Project',
    deleteProject: 'Delete',
    projectName: 'Project Name',
    projectUrl: 'Project URL (optional)',
    projectImage: 'Image URL (or upload below)',
    uploadImage: 'Upload Image',
    saveProject: 'Save',
    cancelBtn: 'Cancel',
    confirmDelete: 'Are you sure you want to delete this project?',
    yes: 'Yes',
    no: 'No',
    visitProject: 'Visit Project',
    clickToView: 'Click to Open',
    folders: 'Folders',
    images: 'Images',
    createFolder: 'Create Folder',
    editFolder: 'Edit Folder',
    folderName: 'Folder Name',
    emptyFolder: 'Empty Folder',
    uploadImages: 'Upload Images',
    addImageUrl: 'Add Image URL',
    addImage: 'Add Image',
    noImages: 'No images in this folder yet.',
    confirmDeleteImage: 'Delete this image?',

    // Admin Panel
    adminDashboard: 'Admin Dashboard',
    adminLoginSub: 'Enter password to access the admin panel',
    adminCreateNew: 'New Work Sample',
    adminManageImages: 'Manage Images',
    adminTotalSamples: 'Work Samples',
    adminTotalImages: 'Total Images',
    adminFeatured: 'Featured',
    adminCategories: 'Categories',
    adminSearchPlaceholder: 'Search work samples...',
    adminCreateFirst: 'Create your first work sample',
    adminNoResults: 'No results found',
    adminThumb: 'Thumb',
    adminCategory: 'Category',
    adminTech: 'Technologies',
    adminActions: 'Actions',
    adminDescription: 'Description',
    adminGithubUrl: 'GitHub URL',
    adminMarkFeatured: 'Mark as Featured',
    adminUpdate: 'Update',
    adminNamePlaceholder: 'Enter project name',
    adminDescPlaceholder: 'Describe this work sample...',
    adminCategoryPlaceholder: 'e.g. Web App, Mobile, UI/UX',
    adminTechPlaceholder: 'React, Node.js, Supabase',
    adminCreated: 'Work sample created!',
    adminUpdated: 'Work sample updated!',
    adminDeleted: 'Work sample deleted!',
    adminErrorSaving: 'Error saving work sample',
    adminErrorDeleting: 'Error deleting work sample',
    adminLoading: 'Loading...',

    // AI
    aiTag: 'AI Assistant',
    aiTitle: 'AI Assistant',
    aiSubtitle: "Powered by AI — ask anything about Adham Shams's skills, experience, or how to get in touch.",
    aiGreeting: "Hey! 👋 I'm Adham Shams's AI assistant. Ask me about his skills, experience, projects, or how to hire him!",
    aiPlaceholder: 'Ask me anything...',
    aiName: "Adham Shams's AI Assistant",
    aiOnline: 'Online',

    // Contact
    contactTag: 'Get In Touch',
    contactTitle: 'Get In Touch',
    contactSubtitle: "Have a project in mind? Let's work together to bring your ideas to life!",
    letsConnect: "Let's Connect",
    contactDescription: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision. Feel free to reach out through any of the following channels:",
    phone: 'Phone',
    email: 'Email',
    telegramChannel: 'Telegram',
    joinChannel: 'Join Channel',
    availableFreelance: 'Available for Freelance Work',
    whatsapp: 'WhatsApp',

    // Footer
    footerTagline: 'Crafted with passion & code.',
    allRights: 'All Rights Reserved.',
    madeWith: 'Crafted with passion & code.'
  },
  ar: {
    // Navbar
    home: 'الرئيسية',
    about: 'عني',
    skills: 'المهارات',
    portfolio: 'المشاريع',
    ai: 'الذكاء',
    contact: 'تواصل',
    hireMeNav: 'وظفني',

    // Hero
    greeting: 'مرحباً، أنا',
    title: 'مطور برمجيات',
    description: 'مطور مستقل شغوف بخبرة أكثر من 3 سنوات في إنشاء تطبيقات ويب حديثة ومتجاوبة باستخدام أحدث التقنيات.',
    yearsExp: 'سنوات خبرة',
    projectsCompleted: 'مشروع',
    happyClients: 'عميل',
    hireMe: 'دعنا نعمل معاً',
    viewWork: 'شاهد أعمالي',
    scrollDown: 'اسحب',
    typingTexts: ['متخصص React', 'مطور Vue.js', 'مهندس برمجيات', 'خبير Node.js'],
    fastDelivery: 'تسليم سريع',
    topRated: 'تقييم عالي',

    // About
    aboutTag: 'نبذة عني',
    aboutTitle: 'نبذة عني',
    whoAmI: 'من أنا؟',
    aboutDescription: 'أنا مطور برمجيات من مصر مع أكثر من 3 سنوات من الخبرة في العمل الحر. طورت خبرة في تقنيات الواجهة الأمامية والخلفية، لإنشاء تجارب رقمية سلسة وحل المشاكل المعقدة بكود نظيف وفعال.',
    name: 'الاسم',
    age: 'العمر',
    years: 'سنة',
    status: 'الحالة',
    freelancer: 'مستقل',
    from: 'من',
    fromValue: 'مصر',
    experience: 'الخبرة',
    frontendDev: 'تطوير الواجهة الأمامية',
    frontendDesc: 'إنشاء واجهات مستخدم جميلة ومتجاوبة باستخدام أطر حديثة مثل React و Next.js و Vue.js و Nuxt.js.',
    backendDev: 'تطوير الخادم',
    backendDesc: 'بناء تطبيقات خادم قوية مع واجهات برمجة آمنة وقواعد بيانات فعالة.',
    fullstackDev: 'حلول برمجية',
    fullstackDesc: 'تطوير تطبيقات ويب شاملة من الفكرة إلى النشر باستخدام أحدث التقنيات.',
    letsWork: 'دعنا نعمل معاً',

    // Skills
    skillsTag: 'مهاراتي',
    skillsTitle: 'مهاراتي',
    skillsSubtitle: 'التقنيات التي أعمل بها يومياً لبناء تطبيقات ويب حديثة.',
    frontend: 'الواجهة الأمامية',
    backend: 'الخادم',
    otherSkills: 'أخرى',

    // Projects
    projectsTag: 'معرض الأعمال',
    projectsTitle: 'نماذج من أعمالي',
    projectsSubtitle: 'عرض لمشاريعي الأخيرة ونماذج أعمالي.',
    noProjects: 'لا توجد نماذج أعمال بعد.',
    adminLogin: 'دخول المدير',
    adminLogout: 'تسجيل خروج',
    enterPassword: 'أدخل كلمة مرور المدير',
    loginBtn: 'دخول',
    wrongPassword: 'كلمة المرور خاطئة!',
    addProject: 'إضافة مشروع',
    editProject: 'تعديل المشروع',
    deleteProject: 'حذف',
    projectName: 'اسم المشروع',
    projectUrl: 'رابط المشروع (اختياري)',
    projectImage: 'رابط الصورة (أو ارفع أدناه)',
    uploadImage: 'رفع صورة',
    saveProject: 'حفظ',
    cancelBtn: 'إلغاء',
    confirmDelete: 'هل أنت متأكد أنك تريد حذف هذا المشروع؟',
    yes: 'نعم',
    no: 'لا',
    visitProject: 'زيارة المشروع',
    clickToView: 'اضغط لفتح المشاريع',
    folders: 'مجلدات',
    images: 'صور',
    createFolder: 'إنشاء مجلد',
    editFolder: 'تعديل المجلد',
    folderName: 'اسم المجلد',
    emptyFolder: 'مجلد فارغ',
    uploadImages: 'رفع صور',
    addImageUrl: 'إضافة رابط صورة',
    addImage: 'إضافة صورة',
    noImages: 'لا توجد صور في هذا المجلد بعد.',
    confirmDeleteImage: 'حذف هذه الصورة؟',

    // Admin Panel
    adminDashboard: 'لوحة التحكم',
    adminLoginSub: 'أدخل كلمة المرور للوصول إلى لوحة التحكم',
    adminCreateNew: 'نموذج عمل جديد',
    adminManageImages: 'إدارة الصور',
    adminTotalSamples: 'نماذج الأعمال',
    adminTotalImages: 'إجمالي الصور',
    adminFeatured: 'مميز',
    adminCategories: 'التصنيفات',
    adminSearchPlaceholder: 'البحث في نماذج الأعمال...',
    adminCreateFirst: 'أنشئ أول نموذج عمل',
    adminNoResults: 'لا توجد نتائج',
    adminThumb: 'صورة',
    adminCategory: 'التصنيف',
    adminTech: 'التقنيات',
    adminActions: 'إجراءات',
    adminDescription: 'الوصف',
    adminGithubUrl: 'رابط GitHub',
    adminMarkFeatured: 'تمييز كمشروع مميز',
    adminUpdate: 'تحديث',
    adminNamePlaceholder: 'أدخل اسم المشروع',
    adminDescPlaceholder: 'وصف نموذج العمل...',
    adminCategoryPlaceholder: 'مثال: تطبيق ويب، موبايل، UI/UX',
    adminTechPlaceholder: 'React, Node.js, Supabase',
    adminCreated: 'تم إنشاء نموذج العمل!',
    adminUpdated: 'تم تحديث نموذج العمل!',
    adminDeleted: 'تم حذف نموذج العمل!',
    adminErrorSaving: 'خطأ في حفظ نموذج العمل',
    adminErrorDeleting: 'خطأ في حذف نموذج العمل',
    adminLoading: 'جاري التحميل...',

    // AI
    aiTag: 'مساعد ذكي',
    aiTitle: 'مساعد ذكي',
    aiSubtitle: 'مدعوم بالذكاء الاصطناعي — اسأل أي شيء عن مهارات ادهم شمس أو خبرته أو كيفية التواصل.',
    aiGreeting: 'مرحباً! 👋 أنا مساعد ادهم شمس الذكي. اسألني عن مهاراته أو خبرته أو مشاريعه أو كيفية توظيفه!',
    aiPlaceholder: 'اسألني أي شيء...',
    aiName: 'مساعد ادهم شمس الذكي',
    aiOnline: 'متصل',

    // Contact
    contactTag: 'تواصل معي',
    contactTitle: 'تواصل معي',
    contactSubtitle: 'هل لديك مشروع في ذهنك؟ دعنا نعمل معاً لتحقيق أفكارك!',
    letsConnect: 'دعنا نتواصل',
    contactDescription: 'أنا دائماً منفتح لمناقشة المشاريع الجديدة والأفكار الإبداعية أو الفرص لأكون جزءاً من رؤيتك. لا تتردد في التواصل عبر أي من القنوات التالية:',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    telegramChannel: 'تيليجرام',
    joinChannel: 'انضم للقناة',
    availableFreelance: 'متاح للعمل الحر',
    whatsapp: 'واتساب',

    // Footer
    footerTagline: 'صُنع بشغف وإبداع.',
    allRights: 'جميع الحقوق محفوظة.',
    madeWith: 'صُنع بشغف وإبداع.'
  }
};

export default translations;
